export enum DiagnocoinHistoryFilter {
  all = 'all',
  purchases = 'purchases',
  deductions = 'deductions',
  refunds = 'refunds',
}
